import { render, staticRenderFns } from "./Sponsorship.vue?vue&type=template&id=b7ff188c&scoped=true"
import script from "./Sponsorship.vue?vue&type=script&lang=js"
export * from "./Sponsorship.vue?vue&type=script&lang=js"
import style0 from "./Sponsorship.vue?vue&type=style&index=0&id=b7ff188c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ff188c",
  null
  
)

export default component.exports